import { add } from "date-fns";

export const Paths = {
  home: "/",
  users: "/users",
  addUser: "/users/create",
  editUser: "/users/edit",
  userDetails: "/users/details",
  roles: "/roles",
  addRole: "/roles/create",
  editRole: "/roles/edit",
  roleDetails: "/roles/details",
  customers: "/customers",
  addCustomer: "/customers/create",
  editCustomer: "/customers",
  customerDetails: "/customer/details",
  servicePoint: "/service-points",
  stock: "/stock",
  addStock: "/stock/add",
  addStockBulk: "/stock/add/bulk",
  editStock: "/stock/edit",
  stockDetails: "/stock/details",
  locations: "/locations",
  addLocations: "/locations/add",
  editLocations: "/locations/edit",
  locationDetails: "/locations/details",
  assets: "/assets",
  addAssets: "/assets/add",
  editAssets: "/assets/edit",
  cashCenter: "/cash-centers",
  addCashCenter: "/cash-centers/add",
  cashCenterDetails: "/cash-centers",
  editCashCenter: "/cash-centers/edit",
  consumable: "/consumable",
  addConsumable: "/consumable/add",
  consumableSummary: "/consumable/summary",
  consumableDetails: "/consumable/details",
  editConsumable: "/consumable/edit",
  routesList: "/routesList",
  addRoute: "/add-route",
  editRoute: "/edit-route",
  routeDetails: "/route-details",
  notification: "/notification",
  addNotification: "/notification/add",
  notificationDetails: "/notification/details",
  editNotification: "/notification/edit",
  escalationMatrix: "/escalation-matrix",
  addEscalationMatrix: "/escalationMatrix/add",
  editEscalationMatrix: "/escalationMatrix/edit",
  routesList: "/routesList",
  addRoute: "/add-route",
  editRoute: "/edit-route",
  routeDetails: "/route-details",
  profile: "/profile",
  changePassword: "/change-password",
  ticketsList: "/tickets-list",
  vehiclesList: "/vehicles/list",
  addVehicles: "/vehicle/add",
  editVehicle: "/vehicle/edit",
  vehicleDetails: "/vehicle/details",
  currency: "/currency",
  currencyAdd: "/currency/add",
  currencyDetails: "/currency/details",
  currencyEdit: "/currency/edit",

  createOrder: "/create-order",
  orderList: "/order-list",
  viewOrder: "/view-order",
  assignOrder: "/assign-order",
  editOrder: "/edit-order",

  loginCashMile: "/login/cash-mile",
  loginCashMate: "/login/cash-mate",
  loginCashLox: "/login/cash-lox",
  loginCashBoard: "/login/cash-board",
  dashboard: "/dashboard",

  atmReplenishment: "/atm-replenishment",
  newAtmReplenishmentRequest: "/atm-replenishment/create",
  clearance: "/clearance",
  newClearanceRequest: "/clearance/create",
  b2b: "/b2b",
  newB2bRequest: "/b2b/create",
  b2bHub: "b2b/hub",
  cashCollection: "/cash-collection",
  newCashCollectionRequest: "/cash-collection",
  cashDelivery: "/cash-delivery",
  newCashDeliveryRequest: "/cash-delivery/create",
  cassettesReplacement: "/cassettes-replacement",
  newCassettesReplacementRequest: "/cassettes-replacement/create",
  machineClearance: "/machine-clearance",
  newMachineClearanceRequest: "/machine-clearance/create",
  maintenance: "/maintenance",
  newMaintenanceRequest: "/maintenance/create",
  collection: "/collection",
  newCollectionRequest: "/collection/create",
  delivery: "/delivery",
  newDeliveryRequest: "/delivery/create",
};
